export default "__VITE_ASSET__b33adf65__"